import type { CSSProperties } from 'react';
import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type IconCheckCircleFillProps = IconComponentBaseProps;

export const IconCheckCircleFill = ({
  width = 20,
  height = 20,
  fill = defaultTheme.mantineColors.green[6],
  className,
}: IconCheckCircleFillProps) => {
  const maskId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={maskId} style={maskStyle} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M8.81697 11.7885L6.88113 9.85242C6.76572 9.73714 6.62065 9.67811 6.44592 9.67534C6.27134 9.6727 6.12363 9.73172 6.0028 9.85242C5.88211 9.97325 5.82176 10.1196 5.82176 10.2916C5.82176 10.4635 5.88211 10.6099 6.0028 10.7308L8.28967 13.0176C8.44037 13.1682 8.61613 13.2435 8.81697 13.2435C9.0178 13.2435 9.19356 13.1682 9.34426 13.0176L13.9805 8.38138C14.0958 8.26596 14.1548 8.12089 14.1576 7.94617C14.1602 7.77158 14.1012 7.62388 13.9805 7.50304C13.8597 7.38235 13.7133 7.322 13.5413 7.322C13.3694 7.322 13.223 7.38235 13.1022 7.50304L8.81697 11.7885ZM10.0011 17.9166C8.90613 17.9166 7.8769 17.7088 6.91342 17.2933C5.94995 16.8777 5.1119 16.3137 4.39926 15.6014C3.68662 14.889 3.12238 14.0513 2.70655 13.0883C2.29085 12.1252 2.08301 11.0962 2.08301 10.0014C2.08301 8.90638 2.29079 7.87714 2.70634 6.91367C3.1219 5.9502 3.68586 5.11214 4.39822 4.3995C5.11058 3.68686 5.94829 3.12263 6.91134 2.70679C7.8744 2.2911 8.90335 2.08325 9.99822 2.08325C11.0932 2.08325 12.1225 2.29103 13.0859 2.70658C14.0494 3.12214 14.8875 3.6861 15.6001 4.39846C16.3127 5.11082 16.877 5.94853 17.2928 6.91159C17.7085 7.87464 17.9163 8.9036 17.9163 9.99846C17.9163 11.0935 17.7086 12.1227 17.293 13.0862C16.8775 14.0496 16.3135 14.8877 15.6011 15.6003C14.8888 16.313 14.0511 16.8772 13.088 17.293C12.125 17.7087 11.096 17.9166 10.0011 17.9166Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

const maskStyle: CSSProperties = { maskType: 'alpha' };
